// extracted by mini-css-extract-plugin
module.exports = {"galleryBlob":"Gallery_galleryBlob__20yX1","galleryBG":"Gallery_galleryBG__ffEGi"};